import React from "react";
import { FaAndroid } from "react-icons/fa";
import logo from "../../assets/logo.png";

const LandingPageHeader = ({ handleDownloadClick, isDownloading }) => (
  <header className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-200 py-2 px-4 shadow-md relative overflow-hidden">
    <div className="absolute inset-0 bg-yellow-100 opacity-50 animate-pulse"></div>
    <div className="container mx-auto flex items-center justify-between relative z-10">
      <div className="flex items-center group">
        <div className="bg-white rounded-full p-0.5 shadow-md transition-transform duration-300 group-hover:scale-105">
          <img src={logo} alt="TicketFlix Logo" className="h-12 w-12 rounded-full transition-transform duration-300 group-hover:rotate-12" />
        </div>
        <h1 className="ml-2 text-3xl font-extrabold text-gray-800 font-sans tracking-wide transition-all duration-300 group-hover:text-red-600 group-hover:scale-105">
          Ticket<span className="text-red-600 group-hover:text-gray-800">Flix</span>
        </h1>
      </div>
    
      <button
        onClick={handleDownloadClick}
        disabled={isDownloading}
        className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-red-800 to-yellow-700 text-white font-bold rounded-full hover:from-red-700 hover:to-yellow-600 transform hover:scale-105 transition-all duration-300 shadow-lg flex flex-col"
      >
        <div className="flex items-center">
          <FaAndroid className="mr-2 text-lg" />
          <span className="font-bold">Download App</span>
        </div>
      </button>
    </div>
  </header>
);

export default LandingPageHeader;